module.exports = __webpack_public_path__ + "b5b00437a8b306464edb6e3975a0c471.MP3";